import { useQuery } from '@tanstack/react-query';
import { reconciliationApi } from '../services/api-client';
import { reconciliationKeys } from './useReconciliationAlerts';
import type { ReconciliationFindingRow } from '../types';

export function useReconciliationFindings(kind?: string, limit = 100) {
  return useQuery<{ items: ReconciliationFindingRow[] }>({
    queryKey: reconciliationKeys.findings(kind, limit),
    queryFn: () => reconciliationApi.listFindings({ kind, limit }),
    refetchInterval: 30_000,
    staleTime: 10_000,
  });
}
